
import { Component, Mixins } from 'vue-property-decorator';
import { required } from '@vuelidate/validators';
import { makeFormModel, submitForm } from 'ah-common-lib/src/form/helpers';
import { FormValidation, FormEvent } from 'ah-common-lib/src/form/interfaces';
import { email } from 'ah-common-lib/src/form/validators';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';

@Component
export default class ForgottenPasswordView extends Mixins(WithRequestManager) {
  forgottenPasswordForm = makeFormModel({
    name: 'ForgottenPasswordForm',
    fieldType: 'form',
    fields: [
      {
        name: 'email',
        title: 'Email',
        fieldType: 'text',
        errorMessages: {
          required: 'Email is required',
        },
        validators: {
          required,
          email,
        },
      },
    ],
  });

  forgottenPasswordFV: FormValidation | null = null;

  private emailSent = false;

  onFormEvent(formEvent: FormEvent) {
    if (formEvent.event === 'form-field-submit') {
      this.submit();
    }
  }

  get supportEmail() {
    return this.$theme.val?.helpEmail;
  }

  submit() {
    if (this.forgottenPasswordFV?.$invalid) {
      submitForm(this.forgottenPasswordFV);
      return;
    }

    const payload = { email: this.forgottenPasswordForm.email };

    this.requestManager
      .sameOrCancelAndNew('resetPassword', this.$services.account.resetPassword(payload), payload)
      .subscribe(() => {
        this.emailSent = true;
      });
  }
}
